import React from "react";
import { Card, CardBody } from "reactstrap";

type TotalsCardProps = {
  subtotal: number;
  iva: number;
  total: number;
};

const TotalsCard: React.FC<TotalsCardProps> = ({ subtotal, iva, total }) => (
  <Card className="shadow-sm h-100">
    <CardBody>
      <div className="d-flex justify-content-between">
        <p className="mb-2 fw-semibold">Totales</p>
        <span className="text-muted">Guaraníes</span>
      </div>
      <div className="d-flex justify-content-between">
        <span>Subtotal</span>
        <strong>{subtotal.toLocaleString("es-PY", { style: "currency", currency: "PYG" })}</strong>
      </div>
      <div className="d-flex justify-content-between">
        <span>IVA</span>
        <strong>{iva.toLocaleString("es-PY", { style: "currency", currency: "PYG" })}</strong>
      </div>
      <hr />
      <div className="d-flex justify-content-between">
        <span className="text-uppercase">Total</span>
        <strong className="fs-5">
          {total.toLocaleString("es-PY", { style: "currency", currency: "PYG" })}
        </strong>
      </div>
    </CardBody>
  </Card>
);

export default TotalsCard;
